import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { FormSubmissionResponse } from '../../../types/FormSubmission';

type UseGetAllFormSubmissionsParams = {
  page?: number;
  per_page?: number;
  filters?: {
    event_form_template?: string;
  };
};

export type UseGetAllFormSubmissionsProps = {
  params?: UseGetAllFormSubmissionsParams;
  enabled?: boolean;
};

export const fetchAllFormSubmissions = async ({ params }: UseGetAllFormSubmissionsProps) => {
  const response = await CustomAxios.get<FormSubmissionResponse>('form_submissions', { params: { ...params, per_page: params?.per_page ?? 0 } });
  const { data } = response;
  return data;
};

export function useGetAllFormSubmissions({ params, enabled = true }: UseGetAllFormSubmissionsProps) {
  const queryKey: any = [queryKeys.allFormSubmissions, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllFormSubmissions({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
